import React from 'react';
import classNames from 'classnames';
import { Button, ButtonGroup } from 'reactstrap';

export type ButtonType<T> = {
    label: string;
    value: T;
    icon?: string;
    disabled?: boolean;
};

type Props<T> = {
    buttons: ButtonType<T>[];
    selected?: T;
    onClick: (value: T) => void;
    disabled?: boolean;
    className?: string;
};

const ButtonArray = <T extends any>({
    buttons,
    selected,
    disabled = false,
    onClick,
    className,
}: Props<T>) => (
    <ButtonGroup className={className}>
        {buttons.map(button => (
            <Button
                type="button"
                key={button.value}
                onClick={() => onClick(button.value)}
                outline
                className={classNames({ active: String(button.value) === String(selected) })}
                disabled={disabled || button.disabled}
            >
                {button.icon && <i className={classNames('mr-2', button.icon)} />}
                {button.label}
            </Button>
        ))}
    </ButtonGroup>
);

export default ButtonArray;
